module.exports = __webpack_public_path__ + "static/team-022761df657b7ecec5fc1ccae4194713.png";